import { css } from "styled-components";

export type ShimmerMixinProps = { $shimmerEnabled: boolean };

export const ShimmerMixin = css<ShimmerMixinProps>`
    animation-duration: 7.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${({ $shimmerEnabled }) => $shimmerEnabled ? "shimmer" : undefined};
    animation-timing-function: linear;
    background: ${({ $shimmerEnabled }) => $shimmerEnabled ? "linear-gradient(to right,rgba(40,40,40,.11),rgba(210,210,210,.1),rgba(40,40,40,.11));" : undefined};
    background-size: 1200px 100%;

    > * {
        opacity:  ${({ $shimmerEnabled }) => $shimmerEnabled ? "0" : "1"};
    }

    @keyframes shimmer {
    0% {
        background-position: -1200px 0;
    }
    100% {
        background-position: 1200px 0;
    }
}
`;
